import classnames from 'classnames';
import { SfaPlayerNameBlockProps } from './sfaPlayerNameBlock.types';
import styles from './sfaPlayerNameBlock.module.scss';

const SfaPlayerNameBlock = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-player-name-block',
  firstName,
  lastName,
  alignment = 'start',
  headingLevel = 'h1',
}: SfaPlayerNameBlockProps) => {
  const Heading = headingLevel as 'h1' | 'h2' | 'h3';

  return (
    <Heading
      {...nativeProps}
      data-testid={testId}
      className={classnames(
        styles.sfaPlayerNameBlock,
        alignment === 'center' && styles['sfaPlayerNameBlock--center'],
        classNames
      )}
    >
      <span className={styles.firstName}>{firstName}</span>
      <span className={styles.lastName}>{lastName}</span>
    </Heading>
  );
};

export default SfaPlayerNameBlock;
